import { gql } from '@apollo/client';

export const GET_COMPANY_NAME_SLUG_QUERY = gql`
  query CompanyNameSlug(
    $companySlug: String!
    $zone: Zone!
    $isLegacyUrl: Boolean!
  ) {
    companyNameSlug(
      companySlug: $companySlug
      zone: $zone
      isLegacyUrl: $isLegacyUrl
    ) {
      companySlug
      status
    }
  }
`;

export const GET_COMPANY_REVIEW_UPVOTES_QUERY = gql`
  query CompanyProfileReviewUpvotes(
    $companyProfileReviewUpvotesId: ID!
    $zone: Zone!
  ) {
    companyProfileReviewUpvotes(
      id: $companyProfileReviewUpvotesId
      zone: $zone
    ) {
      upvotes
    }
  }
`;

export const POST_COMPANY_REVIEW_UPVOTE_MUTATE = gql`
  mutation PostCompanyProfileReviewUpvotes(
    $input: PostCompanyProfileReviewUpvotesInput!
  ) {
    postCompanyProfileReviewUpvotes(input: $input) {
      success
    }
  }
`;

export const POST_COMPANY_REVIEW_FLAG_MUTATE = gql`
  mutation PostCompanyProfileReviewFlag(
    $input: PostCompanyProfileReviewFlagInput!
  ) {
    postCompanyProfileReviewFlag(input: $input) {
      success
    }
  }
`;

export const GET_REVIEWS_QUERY = gql`
  query CompanyReviews(
    $companyProfileId: ID!
    $newCompanyProfileId: CompanyId!
    $zone: Zone!
    $page: Int
    $sort: String
    $perPage: Int
    $locationId: ID
    $locale: Locale!
  ) {
    companyProfile(id: $companyProfileId, zone: $zone) {
      branding {
        logo
      }
      reviewsSummary {
        overallRating {
          value
          numberOfReviews {
            value
          }
        }
      }
    }
    companyDetails(id: $newCompanyProfileId) {
      id
      companyReviews(
        zone: $zone
        page: $page
        sort: $sort
        perPage: $perPage
        locationId: $locationId
      ) {
        data {
          companyId
          pros
          cons
          overallExperienceDetails
          schemaVersion
          jobTitle
          title
          id
          workLocation
          upvotes {
            count
            description(locale: $locale)
            userIds
          }
          salarySummary(locale: $locale)
          employmentStatus(locale: $locale)
          recommended {
            description(locale: $locale)
            value
          }
          ratings {
            value
            description(locale: $locale)
          }
          overallRating
          createdAt {
            shortAbsoluteLabel
          }
          reply {
            createdAt {
              dateTime
            }
            from
            userId
            text
          }
        }
        paging {
          page
          perPage
          total
          totalPages
        }
      }
    }
  }
`;

export const GET_GROUPED_COMPANIES_QUERY = gql`
  query GroupedCompanies(
    $groupBy: CompanyGroupByInput!
    $perPage: Int
    $sortBy: COMPANY_SORT_BY
    $randomSeed: String
    $zone: Zone!
    $excludedCompanyIds: [ID!]
  ) {
    groupedCompanies(
      groupBy: $groupBy
      perPage: $perPage
      sortBy: $sortBy
      randomSeed: $randomSeed
      zone: $zone
      excludedCompanyIds: $excludedCompanyIds
    ) {
      companies {
        id
        name
        slug
      }
      groupName
    }
  }
`;

export const GET_COMPANY_PROFILES_BY_NAME_QUERY = gql`
  query SearchCompanies(
    $name: String!
    $includeBranding: Boolean!
    $limit: Int
  ) {
    searchCompanyProfilesByName(
      name: $name
      includeBranding: $includeBranding
      limit: $limit
    ) {
      companyId
      data {
        name
        branding {
          logo
        }
        published
      }
      organisationId
      zone
    }
  }
`;

export const GET_SEARCH_COMPANY_PROFILES_QUERY = gql`
  query SearchCompanyProfiles($filter: SearchCompanyDetailsFilterInput) {
    searchCompanyDetails(filter: $filter) {
      paging {
        page
        perPage
        total
        totalPages
      }
      data {
        logoUrl
        companyId
        companySlug
        name
        overallRating {
          rating
          count
        }
        organisationId
      }
    }
  }
`;
